import exportFromJSON from 'export-from-json';
import React, { useState, useEffect } from 'react';

import Bouton from '../../UI/Bouton/Bouton';
import FormulaireSelectionEmailgroup from '../Ajouter/FormulaireSelectionEmailgroup/FormulaireSelectionEmailgroup';
import FormulaireSelectionImportFilter from '../Ajouter/FormulaireSelectionImportFilter/FormulaireSelectionImportFilter';
import FormulaireSelectionProjet from '../Ajouter/FormulaireSelectionProjet/FormulaireSelectionProjet';
import FormulaireSelectionSensorType from '../Ajouter/FormulaireSelectionSensorType/FormulaireSelectionSensorType';
import ModifierComposante from './TableauComposante/ModifierComposante/ModifierComposante';
import TableauComposante from './TableauComposante/TableauComposante';

import AccesRestreins from '../../../hoc/AccesRestreins/AccesRestreins';
import AttenteRequete from '../../../hoc/AttenteRequete/AttenteRequete';
import Collapse from '../../../hoc/Collapse/Collapse';

import { AiOutlineCopy } from 'react-icons/ai';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import {
  MdClose,
  MdDone,
  MdModeEdit,
  MdVerticalAlignBottom,
} from 'react-icons/md';
import { checkMot } from '../../../ressources/functionJS/checkMot';
import { confirmeOnClick } from '../../../ressources/functionJS/confirmeOnClick';
import { stringOrEmptyString } from '../../../ressources/functionJS/stringOrEmptyString';
import * as privilege from '../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../ressources/glossaires/glossaire_requetes';
import { glossaire_time_zone } from '../../../ressources/glossaires/glossaire_time_zones';
import * as type_btn from '../../../ressources/glossaires/glossaire_type_de_bouton';
import * as s from '../../../ressources/StyleGlobal/StyleGlobal';
import styles from './ProfilCapteur.module.scss';

const ProfilCapteur = ({ infoCapteur, reqModifier, ajouter, reqSupprimer }) => {
  // Split state into multiple useState hooks
  const [sensorId, setSensorId] = useState(infoCapteur.sensor_id);
  const [projectId, setProjectId] = useState(infoCapteur.project_id);
  const [typeId, setTypeId] = useState(infoCapteur.type_id);
  const [sensorName, setSensorName] = useState(infoCapteur.sensor_name);
  const [sensorsGroup, setSensorsGroup] = useState(infoCapteur.sensors_group);
  const [remarks, setRemarks] = useState(infoCapteur.remarks);
  const [formatDate, setFormatDate] = useState(infoCapteur.format_date);
  const [pathAsciiFile, setPathAsciiFile] = useState(
    infoCapteur.path_ascii_file
  );
  const [position, setPosition] = useState(infoCapteur.position);
  const [importFilterId, setImportFilterId] = useState(
    infoCapteur.import_filter_id
  );
  const [emailgroupId, setEmailgroupId] = useState(infoCapteur.emailgroup_id);
  const [active, setActive] = useState(infoCapteur.active);
  const [sensorProjection, setSensorProjection] = useState(
    infoCapteur.sensor_projection
  );
  const [coordinateX, setCoordinateX] = useState(infoCapteur.coordinate_x);
  const [coordinateY, setCoordinateY] = useState(infoCapteur.coordinate_y);
  const [coordinateZ, setCoordinateZ] = useState(infoCapteur.coordinate_z);
  const [timeZone, setTimeZone] = useState(infoCapteur.time_zone);
  const [watchdog, setWatchdog] = useState(infoCapteur.watchdog);
  const [criticiteId, setCriticiteId] = useState(infoCapteur.criticite_id);
  const [componentList, setComponentList] = useState(
    infoCapteur.component_list
  );
  const [showModify, setShowModify] = useState(false);
  const [showDuplicate, setShowDuplicate] = useState(false);

  // Effect to sync with infoCapteur changes
  useEffect(() => {
    setSensorId(infoCapteur.sensor_id);
    setProjectId(infoCapteur.project_id);
    setTypeId(infoCapteur.type_id);
    setSensorName(infoCapteur.sensor_name);
    setSensorsGroup(infoCapteur.sensors_group);
    setRemarks(infoCapteur.remarks);
    setFormatDate(infoCapteur.format_date);
    setPathAsciiFile(infoCapteur.path_ascii_file);
    setPosition(infoCapteur.position);
    setImportFilterId(infoCapteur.import_filter_id);
    setEmailgroupId(infoCapteur.emailgroup_id);
    setActive(infoCapteur.active);
    setSensorProjection(infoCapteur.sensor_projection);
    setCoordinateX(infoCapteur.coordinate_x);
    setCoordinateY(infoCapteur.coordinate_y);
    setCoordinateZ(infoCapteur.coordinate_z);
    setTimeZone(infoCapteur.time_zone);
    setWatchdog(infoCapteur.watchdog);
    setCriticiteId(infoCapteur.criticite_id);
    setComponentList(infoCapteur.component_list);
    setShowModify(false);
  }, [infoCapteur]);

  const handleModify = () => {
    const modifiedSensor = {
      sensor_id: parseInt(sensorId),
      project_id: parseInt(projectId),
      type_id: parseInt(typeId),
      sensor_name: stringOrEmptyString(sensorName),
      sensors_group: stringOrEmptyString(sensorsGroup),
      remarks: stringOrEmptyString(remarks),
      format_date: stringOrEmptyString(formatDate),
      path_ascii_file: stringOrEmptyString(pathAsciiFile),
      position: stringOrEmptyString(position + ''),
      import_filter_id: parseInt(importFilterId),
      emailgroup_id: parseInt(emailgroupId),
      active: parseInt(active),
      sensor_projection: parseInt(sensorProjection),
      coordinate_x: parseFloat(coordinateX),
      coordinate_y: parseFloat(coordinateY),
      coordinate_z: parseFloat(coordinateZ),
      time_zone: timeZone,
      watchdog: parseInt(watchdog),
      criticite_id: parseInt(criticiteId),
      component_list: componentList,
    };
    reqModifier(modifiedSensor);
    setShowModify(false);
  };

  const handleDuplicate = () => {
    const duplicatedSensor = {
      project_id: parseInt(projectId),
      type_id: parseInt(typeId),
      sensor_name: `Capteur duplique ${sensorName}`,
      sensors_group: stringOrEmptyString(sensorsGroup),
      remarks: stringOrEmptyString(remarks),
      format_date: stringOrEmptyString(formatDate),
      path_ascii_file: stringOrEmptyString(pathAsciiFile),
      position: stringOrEmptyString(position + ''),
      import_filter_id: parseInt(importFilterId),
      emailgroup_id: parseInt(emailgroupId),
      active: parseInt(active),
      sensor_projection: parseInt(sensorProjection),
      coordinate_x: parseFloat(coordinateX),
      coordinate_y: parseFloat(coordinateY),
      coordinate_z: parseFloat(coordinateZ),
      time_zone: timeZone,
      watchdog: parseInt(watchdog),
      criticite_id: parseInt(criticiteId),
      component_list: componentList,
    };
    ajouter(duplicatedSensor);
    setShowDuplicate(false);
  };

  const exportConfig = () => {
    const data = infoCapteur;
    const fileName = `${infoCapteur.project_id}-${infoCapteur.sensor_name}`;
    exportFromJSON({ data, fileName, exportType: 'json' });
  };

  // Render helper functions
  const renderModifyForm = () => (
    <>
      <div className={s.row}>
        <div className={[s.col_12, s.text_left].join(' ')}>
          <Collapse expandText={checkMot('modifier_info_general')}>
            <div className={s.row}>
              <div className={s.col_12}>
                <FormulaireSelectionProjet
                  gererProjetId={setProjectId}
                  preconfigurerProjetId={infoCapteur.project_id}
                />
              </div>
              <div className={s.col_12}>
                <FormulaireSelectionSensorType
                  gererSensorTypeId={setTypeId}
                  preconfigurerSensorTypeId={infoCapteur.type_id}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('nom')}
                </label>
                <input
                  onChange={(e) => setSensorName(e.target.value)}
                  name="info_text_sensor_name"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensor_name}
                  value={sensorName}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('groupe_de_capteurs')}
                </label>
                <input
                  onChange={(e) => setSensorsGroup(e.target.value)}
                  name="info_text_sensors_group"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensors_group}
                  value={sensorsGroup}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('remarques')}
                </label>
                <input
                  onChange={(e) => setRemarks(e.target.value)}
                  name="info_text_remarks"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.remarks}
                  value={remarks}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('format_date')}
                </label>

                <input
                  onChange={(e) => setFormatDate(e.target.value)}
                  name="info_text_format_date"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.format_date}
                  value={formatDate}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('chemin_fichier_ascii')}
                </label>

                <input
                  onChange={(e) => setPathAsciiFile(e.target.value)}
                  name="info_text_path_ascii_file"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.path_ascii_file}
                  value={pathAsciiFile}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('position')}
                </label>
                <input
                  onChange={(e) => setPosition(e.target.value)}
                  name="info_text_position"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.position}
                  value={position}
                />
              </div>
            </div>
          </Collapse>
          <Collapse expandText={checkMot('modifier_info_avance')}>
            <div className={s.row}>
              <div className={s.col_12}>
                <FormulaireSelectionImportFilter
                  gererImportFilterId={setImportFilterId}
                  preconfigurerImportFilterId={infoCapteur.import_filter_id}
                />
              </div>
              <div className={s.col_12}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('id_du_groupe')}
                </label>
                <FormulaireSelectionEmailgroup
                  gererEmailgroupId={setEmailgroupId}
                  preconfigurerEmailgroupId={infoCapteur.emailgroup_id}
                />
              </div>
              <div className={s.col_12}>
                <div className={styles.capteurActive}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('activite_au_capteur')}
                  </label>
                  <select
                    value={active}
                    onChange={(e) => setActive(parseInt(e.target.value))}
                    name="info_text_active"
                    className={[s.custom_select, s.mr_sm_2].join(' ')}
                  >
                    <option value={1}>{checkMot('active')}</option>
                    <option value={0}>{checkMot('desactive')}</option>
                  </select>
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('repere_du_capteur')}
                </label>
                <input
                  onChange={(e) =>
                    setSensorProjection(parseInt(e.target.value))
                  }
                  name="info_text_sensor_projection"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensor_projection}
                  value={sensorProjection}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_x')}
                </label>
                <input
                  onChange={(e) => setCoordinateX(parseFloat(e.target.value))}
                  name="info_text_coordinate_x"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_x}
                  value={coordinateX}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_y')}
                </label>
                <input
                  onChange={(e) => setCoordinateY(parseFloat(e.target.value))}
                  name="info_text_coordinate_y"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_y}
                  value={coordinateY}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_z')}
                </label>
                <input
                  onChange={(e) => setCoordinateZ(parseFloat(e.target.value))}
                  name="info_text_coordinate_z"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_z}
                  value={coordinateZ}
                />
              </div>
              <div className={s.col_12}>
                <div className={styles.capteurActive}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('time_zone')}
                  </label>
                  <input
                    list="timezones"
                    value={timeZone}
                    onChange={(e) => setTimeZone(e.target.value)}
                    name="time_zone"
                    className={styles.text_general}
                  />

                  <datalist id="timezones">
                    <option disabled={true} selected={true}>
                      Selecione um fuso horário
                    </option>
                    {glossaire_time_zone.map((timezone) => (
                      <option value={timezone} selected={timeZone === timezone}>
                        {timezone}
                      </option>
                    ))}
                  </datalist>
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('watchdog')} {checkMot('(en minutes)')}
                </label>
                <input
                  onChange={(e) => setWatchdog(parseInt(e.target.value))}
                  name="info_text_watchdog"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.watchdog}
                  value={watchdog}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('criticite_id')}
                </label>
                <input
                  onChange={(e) => setCriticiteId(parseInt(e.target.value))}
                  name="info_text_criticite_id"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.criticite_id}
                  value={criticiteId}
                />
              </div>
            </div>
          </Collapse>

          <div className={styles.composanteCapteur}>
            <Collapse expandText={checkMot('tableau_de_composant')}>
              <ModifierComposante
                sensor_id={infoCapteur.sensor_id}
                component_list={infoCapteur.component_list}
                gererComposantes={setComponentList}
              />
            </Collapse>
          </div>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.col_md_6}>
          <Bouton
            cliquer={() => setShowModify(false)}
            ajoutClass={styles.bts}
            type={type_btn.danger}
          >
            <MdClose /> {checkMot('annuler')}
          </Bouton>
        </div>
        <div className={[s.col_md_6, s.text_left].join('')}>
          <AttenteRequete
            request_type={requestType.modification_d_un_capteur}
            str={checkMot('modification_en_cours')}
          >
            <Bouton
              cliquer={handleModify}
              ajoutClass={styles.bts}
              type={type_btn.succes}
            >
              <MdDone /> {checkMot('enregistre')}
            </Bouton>
          </AttenteRequete>
        </div>
      </div>
    </>
  );

  const renderDuplicateForm = () => (
    <>
      <div className={s.row}>
        <div className={[s.col_12, s.text_left].join(' ')}>
          <Collapse expandText={checkMot('modifier_info_general')}>
            <div className={s.row}>
              <div className={s.col_12}>
                <FormulaireSelectionProjet
                  gererProjetId={setProjectId}
                  preconfigurerProjetId={infoCapteur.project_id}
                />
              </div>
              <div className={s.col_12}>
                <FormulaireSelectionSensorType
                  gererSensorTypeId={setTypeId}
                  preconfigurerSensorTypeId={infoCapteur.type_id}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('nom')}
                </label>
                <input
                  onChange={(e) => setSensorName(e.target.value)}
                  name="info_text_sensor_name"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensor_name}
                  value={sensorName}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('groupe_de_capteurs')}
                </label>
                <input
                  onChange={(e) => setSensorsGroup(e.target.value)}
                  name="info_text_sensors_group"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensors_group}
                  value={sensorsGroup}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('remarques')}
                </label>
                <input
                  onChange={(e) => setRemarks(e.target.value)}
                  name="info_text_remarks"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.remarks}
                  value={remarks}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('format_date')}
                </label>

                <input
                  onChange={(e) => setFormatDate(e.target.value)}
                  name="info_text_format_date"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.format_date}
                  value={formatDate}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('chemin_fichier_ascii')}
                </label>

                <input
                  onChange={(e) => setPathAsciiFile(e.target.value)}
                  name="info_text_path_ascii_file"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.path_ascii_file}
                  value={pathAsciiFile}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('position')}
                </label>
                <input
                  onChange={(e) => setPosition(e.target.value)}
                  name="info_text_position"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.position}
                  value={position}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('watchdog')}
                  {checkMot('(en minutes)')}
                </label>
                <input
                  onChange={(e) => setWatchdog(parseInt(e.target.value))}
                  name="watchdog"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.position}
                  value={position}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('criticite_id')}
                </label>
                <input
                  onChange={(e) => setCriticiteId(parseInt(e.target.value))}
                  name="criticite_id"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.position}
                  value={position}
                />
              </div>
            </div>
          </Collapse>
          <Collapse expandText={checkMot('modifier_info_avance')}>
            <div className={s.row}>
              <div className={s.col_12}>
                <FormulaireSelectionImportFilter
                  gererImportFilterId={setImportFilterId}
                  preconfigurerImportFilterId={infoCapteur.import_filter_id}
                />
              </div>
              <div className={s.col_12}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('id_du_groupe')}
                </label>
                <FormulaireSelectionEmailgroup
                  gererEmailgroupId={setEmailgroupId}
                  preconfigurerEmailgroupId={infoCapteur.emailgroup_id}
                />
              </div>
              <div className={s.col_12}>
                <div className={styles.capteurActive}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('activite_au_capteur')}
                  </label>
                  <select
                    value={active}
                    onChange={(e) => setActive(parseInt(e.target.value))}
                    name="info_text_active"
                    className={[s.custom_select, s.mr_sm_2].join(' ')}
                  >
                    <option value={1}>{checkMot('active')}</option>
                    <option value={0}>{checkMot('desactive')}</option>
                  </select>
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('repere_du_capteur')}
                </label>
                <input
                  onChange={(e) =>
                    setSensorProjection(parseInt(e.target.value))
                  }
                  name="info_text_sensor_projection"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.sensor_projection}
                  value={sensorProjection}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_x')}
                </label>
                <input
                  onChange={(e) => setCoordinateX(parseFloat(e.target.value))}
                  name="info_text_coordinate_x"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_x}
                  value={coordinateX}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_y')}
                </label>
                <input
                  onChange={(e) => setCoordinateY(parseFloat(e.target.value))}
                  name="info_text_coordinate_y"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_y}
                  value={coordinateY}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('coordonnee_z')}
                </label>
                <input
                  onChange={(e) => setCoordinateZ(parseFloat(e.target.value))}
                  name="info_text_coordinate_z"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.coordinate_z}
                  value={coordinateZ}
                />
              </div>
              <div className={s.col_12}>
                <div className={styles.capteurActive}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('time_zone')}
                  </label>
                  <input
                    list="timezones"
                    value={timeZone}
                    onChange={(e) => setTimeZone(e.target.value)}
                    name="time_zone"
                    className={styles.text_general}
                  />

                  <datalist id="timezones">
                    <option disabled={true} selected={true}>
                      Selecione um fuso horário
                    </option>
                    {glossaire_time_zone.map((timezone) => (
                      <option value={timezone} selected={timeZone === timezone}>
                        {timezone}
                      </option>
                    ))}
                  </datalist>
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('watchdog')} {checkMot('(en minutes)')}
                </label>
                <input
                  onChange={(e) => setWatchdog(parseInt(e.target.value))}
                  name="info_text_watchdog"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.watchdog}
                  value={watchdog}
                />
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {checkMot('criticite_id')}
                </label>
                <input
                  onChange={(e) => setCriticiteId(parseInt(e.target.value))}
                  name="info_text_criticite_id"
                  className={styles.text_general_b}
                  placeholder={infoCapteur.criticite_id}
                  value={criticiteId}
                />
              </div>
            </div>
          </Collapse>

          <div className={styles.composanteCapteur}>
            <Collapse expandText={checkMot('tableau_de_composant')}>
              <ModifierComposante
                component_list={infoCapteur.component_list}
                gererComposantes={setComponentList}
              />
            </Collapse>
          </div>
        </div>
      </div>
      <div className={s.row}>
        <div className={s.col_md_6}>
          <Bouton
            cliquer={() => setShowDuplicate(false)}
            ajoutClass={styles.bts}
            type={type_btn.danger}
          >
            <MdClose /> {checkMot('annuler')}
          </Bouton>
        </div>
        <div className={[s.col_md_6, s.text_left].join('')}>
          <AttenteRequete
            request_type={requestType.modification_d_un_capteur}
            str={checkMot('modification_en_cours')}
          >
            <Bouton
              cliquer={handleDuplicate}
              ajoutClass={styles.bts}
              type={type_btn.succes}
            >
              <MdDone /> {checkMot('creer')}
            </Bouton>
          </AttenteRequete>
        </div>
      </div>
    </>
  );

  const renderProfile = () => (
    <>
      <div className={s.row}>
        <div className={[s.col_xl_12, s.text_left].join(' ')}>
          <Collapse expandText={checkMot('info_general')}>
            <div className={s.row}>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('projet_id')}
                </label>
                <div className={[styles.text_general].join(' ')}>
                  {infoCapteur.project_id}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('id_type')}
                </label>
                <div className={styles.text_general}>{infoCapteur.type_id}</div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('nom')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.sensor_name}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('groupe_de_capteurs')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.sensors_group}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('format_date')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.format_date}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('remarques')}
                </label>
                <div className={styles.text_general}>{infoCapteur.remarks}</div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('chemin_fichier_ascii')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.path_ascii_file}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('position')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.position}
                </div>
              </div>
            </div>
          </Collapse>
          <Collapse expandText={checkMot('info_avance')}>
            <div className={s.row}>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('filtre_importation_id')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.import_filter_id}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('id_du_groupe')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.emailgroup_id}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('activite_au_capteur')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.active
                    ? checkMot('active')
                    : checkMot('desactive')}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('repere_du_capteur')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.sensor_projection}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('coordonnee_x')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.coordinate_x}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('coordonnee_y')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.coordinate_y}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('coordonnee_z')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.coordinate_z}
                </div>
              </div>
              <div className={s.col_12}>
                <div className={styles.capteurActive}>
                  <label className={[styles.taglabel].join(' ')}>
                    {checkMot('time_zone')}
                  </label>
                  <select
                    value={timeZone}
                    onChange={(e) => setTimeZone(e.target.value)}
                    name="info_text_time_zone"
                    className={[s.custom_select, s.mr_sm_2].join(' ')}
                  >
                    {glossaire_time_zone.map((timezone) => (
                      <option selected={timeZone} value={timezone}>
                        {timezone}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('watchdog')} {checkMot('(en minutes)')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.watchdog}
                </div>
              </div>
              <div className={s.col_6}>
                <label className={[styles.taglabel].join(' ')}>
                  {' '}
                  {checkMot('criticite_id')}
                </label>
                <div className={styles.text_general}>
                  {infoCapteur.criticite_id}
                </div>
              </div>
            </div>
          </Collapse>
        </div>
      </div>

      <div className={styles.composanteCapteur}>
        <Collapse expandText={checkMot('tableau_de_composantes')}>
          <TableauComposante component_list={infoCapteur.component_list} />
        </Collapse>
      </div>

      <div className={styles.sty}>
        <Bouton cliquer={() => setShowDuplicate(true)} ajoutClass={styles.bts}>
          <AiOutlineCopy size={15} /> {checkMot('duplique')}
        </Bouton>
        <Bouton cliquer={exportConfig} ajoutClass={styles.bts}>
          <MdVerticalAlignBottom />
          {checkMot('exporter')}
        </Bouton>
        <AccesRestreins numPrivilege={privilege.modifier_des_capteurs}>
          <Bouton cliquer={() => setShowModify(true)} ajoutClass={styles.bts}>
            <MdModeEdit />
            {checkMot('modifier')}
          </Bouton>
        </AccesRestreins>
        <AccesRestreins numPrivilege={privilege.supprimer_des_capteurs}>
          <AttenteRequete
            request_type={requestType.supprimer_un_capteur}
            str={checkMot('suppression_en_cour')}
          >
            <Bouton
              cliquer={() =>
                confirmeOnClick(
                  checkMot('voulez_vous_vraiment_supprimer_ce_capteur'),
                  () => reqSupprimer(infoCapteur.sensor_id)
                )
              }
              ajoutClass={styles.bts}
            >
              <MdClose />
              {checkMot('supprimer')}
            </Bouton>
          </AttenteRequete>
        </AccesRestreins>
      </div>
    </>
  );

  // Main render
  return (
    <div className={styles.ConteneurInfo}>
      <div className={[s.card_header, styles.hedes].join(' ')}>
        <BsFillInfoCircleFill size={14} /> {checkMot('capteur_id')} :{' '}
        {showDuplicate ? ' Capteur duplique' : sensorId}
      </div>
      <div
        className={[
          s.container,
          showModify || showDuplicate ? '' : styles.newStyle,
        ].join(' ')}
      >
        {showModify && renderModifyForm()}
        {showDuplicate && renderDuplicateForm()}
        {!showModify && !showDuplicate && renderProfile()}
      </div>
    </div>
  );
};

export default ProfilCapteur;
